import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
// importing named export so that update functions can be passed
import {ColumnSettingList} from 'components/FlyoutManageViews/components/ViewForms/ColumnSettingList';
import _get from 'lodash/get';
import {getColumnsFromService} from 'api/columnServiceApi';
import {DataExplorerContext} from '../../DataExplorerContext';

export const SummaryColumns = ({setFormIsValid}) => {
	const dataExplorerContext = useContext(DataExplorerContext);
	const {
		bookmark: {explorerData},
		actions,
	} = dataExplorerContext;

	const dataset = useSelector(state => state.datasetList.selected);

	const [columns, setColumns] = useState([]);

	useEffect(() => {
		getColumnsFromService(dataset.datasetId, {
			sources: {
				includeAggregateColumns: true,
			},
			options: {
				embedColumns: true,
			},
		}).then(columnsData => setColumns(columnsData));
	}, []);

	return (
		<ColumnSettingList
			setFormIsValid={setFormIsValid}
			tableType={explorerData.tableType}
			settingType="aggregate"
			columns={columns}
			allSettings={_get(explorerData, 'columns', [])}
			settingList={_get(explorerData, 'columns', []).filter(col => col.columnType === 'aggregate')}
			timeSeriesColumn={_get(explorerData, 'timeseries.column._id')}
			// This function doesn't need to do anything because now changes are recognised in context itself
			setFormHasChanges={() => void 0}
			updateColumns={actions.setColumns}
			updateColumn={actions.updateColumn}
		/>
	);
};

SummaryColumns.propTypes = {
	setFormIsValid: PropTypes.func.isRequired,
};

export default SummaryColumns;
